<template>

    <div class="row h-100 justify-content-center align-items-center bg-info text-light">

        <div class="col-sm-8 col-11" v-if="idea">

            <h1>Idea</h1>

            <div class="form-group mt-4">

                <label for="idea_nombre">¿En que axis impactará?</label>

                <div class="text-left">

                    <div class="custom-control custom-checkbox" v-for="choice in choices" :key="choice">

                        <input
                            type="checkbox"
                            :value="choice"
                            :id="`check-` + choice"
                            v-model="idea.axis"
                            class="custom-control-input"
                        />

                        <label class="custom-control-label" :for="`check-` + choice">{{ choice }}</label>

                    </div>

                </div>

            </div>

            <button class="btn w-100 btn-light btn-lg mt-4" :disabled="disabled" @click="set"> Siguiente </button>

        </div>

    </div>

</template>

<script>
import router from "../router";
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            idea: null,
            choices: ["Delivery", "Marketing", "Productos", "Ventas", "Otros"],
            ...mapGetters(["getIdea"]),
        };
    },
    mounted() {
        this.idea = this.getIdea();
    },
    computed: {
        disabled: function() {
            return this.idea.axis.length == 0;
        },
    },
    methods: {
        set() {
            this.setIdea(this.idea);
            router.push("Idea4");
        },
        ...mapActions(["setIdea"]),
    },
};
</script>

